var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadiology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z",
    fill: "#4C697F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7H13V17H11V7Z",
    fill: "#4C697F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H17V13H7V11Z",
    fill: "#4C697F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9L7 7V9H9Z",
    fill: "#4C697F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H17V7L15 9Z",
    fill: "#4C697F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H7V17L9 15Z",
    fill: "#4C697F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15L17 17V15H15Z",
    fill: "#4C697F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiology);
export default __webpack_public_path__ + "static/media/radiology.7c6383fe7a9c05aa8a9e5c2bfaedbce4.svg";
export { ForwardRef as ReactComponent };